import apiClient from './apiClient';

const AUTH_API_URL = '/api/auth';

const requestAuth = async (path, options = {}) => {
  const response = await fetch(`${AUTH_API_URL}${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(data.message || 'Authentication request failed');
    error.status = response.status;
    error.code = data.code;
    throw error;
  }

  return data;
};

export const getCurrentUser = async () => requestAuth('/me');

export const loginUser = async ({ email, password }) =>
  requestAuth('/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });

export const logoutUser = async () =>
  requestAuth('/logout', {
    method: 'POST',
  });

export const registerUser = async ({ email, password }) => {
  const response = await apiClient.post('/auth/register', { email, password });

  return {
    ...response.data,
    status: response.status,
  };
};
export const requestPasswordReset = async (email) => {
  const response = await apiClient.post('/auth/forgot-password', { email });

  return response.data;
};

export const resetPassword = async (token, password) => {
  const response = await apiClient.post('/auth/reset-password', {
    token,
    password,
  });

  return response.data;
};
